import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const adminApi = {
  createSession: (sessionId) => http.post('/auth/session', null, { headers: { 'X-Session-ID': sessionId } }).then((r) => r.data),
  me: () => http.get('/auth/me').then((r) => r.data),
  logout: () => http.post('/auth/logout').then((r) => r.data),
  summary: () => http.get('/admin/summary').then((r) => r.data),
  quotes: () => http.get('/admin/quotes').then((r) => r.data),
  bookings: () => http.get('/admin/bookings').then((r) => r.data),
  retry: (kind, id) => http.post(`/admin/${kind}/${id}/retry-email`).then((r) => r.data),
};

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/admin';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
